const MODULE_NAME = 'searchService';
class SearchService {
	constructor($http, $q) {
		'ngInject';
		this._$http = $http;
		this.environment = {
			backendUrl: '/api'
		};
		this._apiRoot = `${this.environment.backendUrl}`;
		this._$q = $q;
	}
	getSearchResults(queryText, page, lang) {
		return this._$http({
			method: 'GET',
			url: `${this.environment.backendUrl}/kereso`,
			headers: {
				'Accepts': 'application/json'
			},
			params: {
				q: queryText,
				page: page,
				size: 5,
				lang: lang
			}
		});

	}

}

export default angular.module(MODULE_NAME, []).service('searchService', SearchService).name;




// WEBPACK FOOTER //
// ../source/application/search/search-service.js